export const addTooltipToUnsupportedVariables = (htmlString) => {
  if (!htmlString) return '';

  // Step 1: Remove style='color:red;' if it exists
  // Don't know why we are getting color:red from BE, we've to check with Deeshath on this
  htmlString = htmlString.replace(/style=['"]?color:red;?['"]?/gi, '');

  // Step 2: Replace {{anything}} with a tooltip wrapper
  const processedString = htmlString.replace(
    /(\{\{.*?\}\})/g,
    `<span class="kvariable-tooltip"><span style="background-color: #FFF; border: 1px solid #E9EBF4; padding: 2px 0; border-radius: 6px; font-weight: 450; display: inline-block;" class="kvariable-tooltip-content">$1</span><span class="kvariable-tooltip-text kvariable-template-preview-txt" style="font-weight: 450; left: auto; right: 0px;">Data for this variable is not available yet. It will be filled in when the template is used.</span></span>`
  );

  return processedString;
};

const handleMouseOver = (event) => {
  const tooltipContainer = event.currentTarget;
  const containerBounds = tooltipContainer?.getBoundingClientRect();
  const containerLeft15Percent = (window.innerWidth * 15) / 100;
  const children = tooltipContainer?.getElementsByClassName(
    'kvariable-tooltip-text'
  );
  const variableRightLessWindowHalf =
    containerBounds.right < (window.innerWidth + containerLeft15Percent) / 2;

  if (variableRightLessWindowHalf) {
    if (children?.[0]) {
      children[0].style.position = 'fixed';
      children[0].style.top = `${containerBounds.bottom + 10}px`;
      children[0].style.left = `${
        containerBounds.left - containerLeft15Percent
      }px`;
      children[0].style.visibility = 'visible';
    }
    return;
  } else {
    if (children?.[0]) {
      children[0].classList.add('kvariable-template-preview-txt');
      children[0].style.position = 'fixed';
      children[0].style.top = `${containerBounds.bottom + 10}px`;
      children[0].style.right = `${
        window.innerWidth - containerBounds.right
      }px`;
      children[0].style.left = `inherit`;
      children[0].style.visibility = 'visible';
    }
  }
};

const handleMouseLeave = (event) => {
  const tooltipContainer = event.currentTarget;
  const children = tooltipContainer?.getElementsByClassName(
    'kvariable-tooltip-text'
  );
  if (children?.[0]) {
    children[0].classList.remove('kvariable-template-preview-txt');
    children[0].style.visibility = 'hidden';
  }
};

const clearHoverListerners = () => {
  const elements = document.getElementsByClassName('kvariable-tooltip');
  for (const el of elements) {
    el.removeEventListener('mouseover', handleMouseOver);
    el.removeEventListener('mouseleave', handleMouseLeave);
  }
};

export const addVariableHoverListeners = () => {
  clearHoverListerners();
  setTimeout(() => {
    const elements = document.getElementsByClassName('kvariable-tooltip');
    for (const el of elements) {
      el.addEventListener('mouseover', handleMouseOver);
      el.addEventListener('mouseleave', handleMouseLeave);
    }
  }, 10);
};
